const layoutConfig = {
  name: 'isAbsoluteLayout',
  text: '布局',
  type: 'radioGroup',
  defaultValue: true,
  options: [
    { value: true, text: '固定位置' },
    { value: false, text: '顺序排布' },
  ],
};

export { layoutConfig };

export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [layoutConfig, {
      text: '组件名称',
      name: 'name',
      onChange(vm, v, { model }) {
        // eslint-disable-next-line no-param-reassign,no-underscore-dangle
        model.report._module = v;
      },
    }, {
      text: 'type',
      name: 'type',
      type: 'hidden',
    }, {
      name: 'style',
      items: [{
        name: 'backgroundImage',
        text: '背景图',
        type: 'upload',
        drag: true,
        onChange: async (vm, value = '', { model, formValue }) => {
          let v = value;
          v = v.trim();
          if (v) {
            const imgEl = await new Promise((resolve) => {
              const img = new Image();
              img.onload = function () {
                resolve(this);
              };
              img.src = v;
            });

            const clientWidth = imgEl.width / 2 || model.width;
            formValue.style.width = clientWidth || '100%';
            formValue.style.height = clientWidth * imgEl.height / imgEl.width || '100%';
            model.backgroundSize = '100% 100%';
            model.backgroundRepeat = 'no-repeat';
          } else {
            model.backgroundColor = 'rgba(0, 0, 0, 1)';

            // 如果没有内容，要判断是否有背景图切割标志，有要置为空
            model.backgroundCrop && vm.$delete(model, 'backgroundCrop');
            model.backgroundParts && vm.$delete(model, 'backgroundParts');
          }
        },
      }, {
        type: 'row',
        span: 12,
        items: [{
          name: 'backgroundColor',
          text: '背景颜色',
          type: 'colorPicker',
        }, {
          name: 'backgroundRepeat',
          text: '背景图重复',
          type: 'hidden',
          defaultValue: 'no-repeat',
          options: [
            { text: 'repeat', value: 'repeat' },
            { text: 'repeat-x', value: 'repeat-x' },
            { text: 'repeat-y', value: 'repeat-y' },
            { text: 'no-repeat', value: 'no-repeat' },
            { text: 'inherit', value: 'inherit' },
          ],
        }],
      }, {
        name: 'backgroundSize',
        text: '背景图大小',
        type: 'hidden',
        defaultValue: '100% 100%',
      }],
    }, {
      type: 'component',
      id: 'rect',
    }],
  },
  {
    title: '高级',
    items: [{
      type: 'tab',
      active: '0',
      lazy: true,
      items: [{
        title: '属性',
        labelWidth: '100px',
        items: [{
          name: 'id',
          text: 'ID',
          type: 'display',
        }, {
          text: 'className',
          name: 'className',
        }, {
          type: 'fieldset',
          text: '上报',
          labelWidth: '100px',
          name: 'report',
          extensible: true,
          items: [{
            type: 'row',
            items: [{
              type: 'switch',
              name: 'custom',
              defaultValue: false,
              text: '自定义',
              tip: '选择自定义后可以手动修改上报内容，关闭后会自动生成上报内容',
            }],
          }, {
            name: 'module',
            items: [{
              text: '_module',
              disabled: (vm, { values }) => !values?.report?.custom,
              name: '_module',
            }],
          }],
        }],
      }, {
        type: 'component',
        id: 'script',
      }],
    }],
  },
  ],
}];
